export default __webpack_public_path__ + "source-sans-pro-v11-latin-600-0d1fcd8a62f99a3ef7d325b3fd4cb871.bundle.woff";